import { Cell } from 'react-table'

import { DATETIME_SHORT, formatTime } from 'app/utils/formatDate'

export const DateCell = (cell: Cell) => formatTime(cell?.value, DATETIME_SHORT)
